import {Button} from "react-bootstrap";
import styled from "styled-components";
import Ripples from "react-ripples";

const RipplesAny: any = Ripples;

/** Top and bottom of a CSS margin shorthand ("12px auto 0" → ["12px", "0"]). */
const verticalMargins = (margin: unknown): [string | undefined, string | undefined] => {
  if (typeof margin !== "string" || !margin.trim()) {
    return [undefined, undefined];
  }
  const parts = margin.trim().split(/\s+/);
  return [parts[0], parts.length > 2 ? parts[2] : parts[0]];
};

const RippleButton = (props: any) => {
  // If the button has a color, use the same for the ripple effect but lighter
  // If not, use the default color
  const color = "rgba(0, 0, 0, .3)";
  const positionRippleDiv = props.positionRippleDiv;
  const widthRippleDiv = props.widthRippleDiv;
  // The wrapper clips the ripple to the button's rounded shape, so it must be
  // exactly as tall as the button: vertical margins go on the wrapper instead,
  // or a pill radius cuts into the button. Horizontal ones stay, since callers
  // centre the button inside a wider wrapper with them.
  const [styleTop, styleBottom] = verticalMargins(props.style?.margin);
  const [propTop, propBottom] = verticalMargins(props.margin);
  const marginTop = props.style?.marginTop ?? props.marginTop ?? styleTop ?? propTop;
  const marginBottom = props.style?.marginBottom ?? styleBottom ?? propBottom;
  return (
    <div
      style={{
        borderRadius: props.borderRadius,
        overflow: "hidden",
        display: "inline-flex",
        position: positionRippleDiv,
        width: widthRippleDiv || props.width,
        backgroundColor: "inherit",
        marginTop,
        marginBottom
      }}
    >
      <RipplesAny during={400} color={color} backgroundColor={"inherit"} className={props.classNameRipples}>
        <Button {...props} style={{...props.style, marginTop: 0, marginBottom: 0}}>
          {props.children ? props.children : null}
        </Button>
      </RipplesAny>
    </div>
  );
};

export default RippleButton;

export const StyleButton = styled(RippleButton).attrs((props) => ({
  ...props,
  type: props.type
}))`
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  height: ${(props) => props.height};
  color: ${(props) => props.color || "var(--on-accent)"};
  border: ${(props) => "0"};
  border-color: ${(props) => props.borderColor || "var(--accent)"};
  box-shadow: "unset !important";
  background-color: ${(props) => props.backgroundColor || "var(--accent)"};
  font-family: var(--font-body);
  transition:
    background-color 0.2s,
    color 0.2s;
  display: ${(props) => props.display};
  justify-self: ${(props) => props.justifySelf};
  justify-content: ${(props) => props.justifyContent};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  font-weight: ${(props) => props.fontWeight};
  font-size: ${(props) => props.fontSize};
  position: ${(props) => props.position};
  white-space: ${(props) => props.whiteSpace};
  text-wrap: ${(props) => props.textWrap};
  &:hover,
  &:active,
  &:focus,
  &:visited {
    box-shadow: "unset !important";
    color: ${(props) => props.color || "var(--on-accent)"};
    border-color: var(--accent);
    background-color: ${(props) => props.backgroundColor || "var(--accent-deep) !important"};
  }
`;

export const StyleButtonRound = styled(StyleButton).attrs((props) => ({
  ...props,
  borderRadius: props.borderRadius || "var(--radius-pill)"
}))`
  border-radius: ${(props) => props.borderRadius || "var(--radius-pill)"};
  margin-top: ${(props) => props.marginTop};
`;

export const StyleImageButton = styled.input.attrs((props) => ({
  type: "image",
  src: props.src,
  alt: props.alt
}))`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border: none;
  cursor: pointer;
`;
